// extracted by mini-css-extract-plugin
export var phone = "_3g-0";
export var phoneDragging = "_3g-1";